import React from "react";
import "./Footer.css";
import { FaLinkedin, FaEnvelope, FaArrowUp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Branding */}
        <div className="footer-brand">
          <h2>Monami Som Saha</h2>
          <p>Building the Future with AI, Cybersecurity & Code.</p>
        </div>

        {/* Center Section - Quick Links */}

        {/* Right Section - Socials */}
        <div className="footer-socials">
          <h3>Connect with Me</h3>
          <div className="social-icons">
            <a href="https://www.linkedin.com/in/monami-somsaha/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
            <a href="mailto:monami.somsaha@gmail.com">
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright & Back to Top Button */}
      <div className="footer-bottom">
        <p>© 2025 Monami Som Saha. All Rights Reserved.</p>
        <a href="#" className="back-to-top" onClick={(e) => {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}> 
          <FaArrowUp />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
